// Orçamentos (CRM) salvos a partir do Simulador (conta e ordem). Espelha Quote/QuoteVersion no backend.

// Espelha QuoteStatuses (CVF.Domain/Entities/Quote.cs).
export const QUOTE_STATUSES = ["Rascunho", "Enviado", "Aprovado", "Recusado"] as const;

export type QuoteStatus = (typeof QUOTE_STATUSES)[number];

export interface QuoteVersion {
  id?: string;
  quoteId?: string;
  version: number;
  // Entrada completa do simulador (JSON serializado).
  inputJson: string;
  // Snapshot do resultado (JSON serializado).
  resultJson: string;
  currency: string;
  exchangeRate: number;
  cifBrl: number;
  taxesBrl: number;
  expensesBrl: number;
  disbursementBrl: number;
  finalCostBrl: number;
  createdById?: string | null;
  createdDate?: string;
}

export interface Quote {
  id?: string;
  number: string;
  prospectId?: string | null;
  companyId?: string | null;
  clientName: string;
  product?: string | null;
  status: QuoteStatus | string;
  currentVersion: number;
  approvedVersion?: number | null;
  approvedAt?: string | null;
  validUntil?: string | null;
  processId?: string | null;
  createdById?: string | null;
  notes?: string | null;
  createdDate?: string;
  updatedDate?: string | null;
  versions?: QuoteVersion[];
}

// ---- Extras devolvidos pela API (api/quote) ----

export interface QuoteListItem extends Quote {
  prospectName?: string | null;
  companyName?: string | null;
  // CvfRef do processo vinculado
  processRef?: string | null;
  // Custo final (R$) da versão atual
  finalCostBrl?: number | null;
}

export interface QuoteDetail extends QuoteListItem {
  versions: QuoteVersion[];
}

export interface QuoteFilter {
  search?: string;
  status?: string;
  prospectId?: string;
}

export interface QuoteVersionPayload {
  inputJson: string;
  resultJson: string;
  currency: string;
  exchangeRate: number;
  cifBrl: number;
  taxesBrl: number;
  expensesBrl: number;
  disbursementBrl: number;
  finalCostBrl: number;
}

export interface QuoteHeaderPayload {
  clientName: string;
  prospectId?: string | null;
  companyId?: string | null;
  product?: string | null;
  validUntil?: string | null;
  notes?: string | null;
}

export interface QuoteResult {
  success: boolean;
  notifications: string[];
  id?: string;
}

export interface QuoteComparisonLine {
  key: string;
  label: string;
  isTotal: boolean;
  estimated?: number | null;
  realized?: number | null;
  diff?: number | null;
  diffPercent?: number | null;
}

export interface QuoteComparison {
  linked: boolean;
  quoteId?: string;
  number?: string;
  status?: string;
  clientName?: string;
  versionUsed?: number | null;
  isApproved: boolean;
  duimpAvailable: boolean;
  currency?: string;
  exchangeRate: number;
  lines: QuoteComparisonLine[];
}
